import React from 'react';
import { injectIntl } from 'react-intl';
import { useApolloClient } from '@apollo/client';

import { withStations } from 'components/queries/GetStationsQuery';
import { GET_CACHED_SEARCH_PARAMS } from 'store/queries';

import BookingMagnet from './BookingMagnet';

const BookingMagnetQuery = (props) => {
  const client = useApolloClient();

  const searchParamsData = client.readQuery({
    query: GET_CACHED_SEARCH_PARAMS
  });

  return <BookingMagnet client={client} searchParams={searchParamsData?.searchParams} {...props} />;
};

export default withStations(injectIntl(BookingMagnetQuery));
